<template>
  <div v-loading.fullscreen.lock="fullscreenLoading"></div>
</template>

<script>
import { Loading } from 'element-ui'
import { getCustomerStage, fetchMenuList } from '@/api/customer.js'
import { getCusTypes } from '@/api/set.js'
export default {
  name: 'customerList',
  data () {
    return {
      fullscreenLoading: true,
      homePath: '/home/data-center'
    }
  },
  created () {
    Lockr.rm('currentPath') // 头部高亮的菜单
    Lockr.rm('leftPath') // 左侧高亮的菜单
    this.getMemuList()
  },
  methods: {
    // 动态获取菜单
    async getMemuList () {
      const result = await fetchMenuList()
      const { code, message, result: res } = result.data
      if (code === '200') {
        const { treeList = [], subSystems = [] } = res || {}
        this.subSystems = subSystems
        Lockr.set('subSystems', subSystems)
        // 受众单独处理
        for (let item of treeList) {
          if (item.attributes.perms === 'audiences') {
            this.load(treeList)
            return
          }
        }
        this.menuList = treeList.map(item => {
          // 给每棵树第一层加上path
          const route = item.children.length > 0 ? item.children[0].children[0].attributes.route : item.attributes.route

          return {
            name: item.text,
            id: item.id,
            path: route,
            perms: item.attributes.perms,
            children: item.children,
            pr: item.attributes.pr
          }
        })
        console.log(this.menuList, 'this.menuList')
        Lockr.set('menuList', this.menuList)
        const path = this.menuList[0].path
        router.push(path)
      } else {
        // _g.toastMsg('error', message)
      }
    },
    // 获取受众类型列表
    load (treeList) {
      getCusTypes().then((res) => {
        if (res.data.code == 200) {
          const obj = treeList.find(item => item.attributes.perms === 'audiences')
          // const data = res.data.result.reverse()
          const data = res.data.result
          // 导出功能单独处理 除了导出之外的树
          const children = JSON.parse(JSON.stringify(obj.children))
          obj.children = children.filter(({ attributes }) => attributes.perms !== 'audiences:export')
          // 单独的导出那棵树
          const exportList = children.filter(item => item.attributes.perms === 'audiences:export')
          data.forEach(item => {
            // 去掉订单模型的
            if (item.typeId !== 50) {
              item.text = item.name
              item.attributes = {
                icon: 'iconfont ' + item.icon
              }
              item.children = JSON.parse(JSON.stringify(obj.children))
            }
          })
          // 将导出和getCusTypes接口获取回来的data放在一起
          obj.children = [...data, ...exportList]
          // 改变路径
          data.forEach(({ children, id }) => {
            children.forEach(item => (item.attributes.route = `${item.attributes.route}/${id}`))
          })
          this.menuList = treeList.map(item => {
            // 给每棵树第一层加上path
            const route = item.children.length > 0 ? item.children[0].children[0].attributes.route : item.attributes.route

            return {
              name: item.text,
              id: item.id,
              path: route,
              perms: item.attributes.perms,
              children: item.children,
              pr: item.attributes.pr
            }
          })
          Lockr.set('menuList', this.menuList)
          const path = this.menuList[0].path
          router.push(path)
        }
      })
    },
  }
}
</script>

<style scoped>
</style>
